import React, { useEffect, useState } from "react";
import { getCancelledOrdersService } from "../../../services/apiService";

const AdminCancelledOrderList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
const fetchCancelledOrders = async () => {
  try {
    const data = await getCancelledOrdersService();

    const sortedOrders = (data.data || []).sort(
      (a, b) => new Date(b.orderdate) - new Date(a.orderdate)
    );

    setOrders(sortedOrders);

  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
    fetchCancelledOrders();
  }, []);

  const totalPages = Math.ceil(orders.length / pageSize);
  const paginatedOrders = orders.slice((page - 1) * pageSize, page * pageSize);

  if (loading) return <div style={{ padding: "20px" }}>Loading cancelled orders...</div>;

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ color: "#005487", marginBottom: "15px" }}>Cancelled Orders</h2>

      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#f5f5f5" }}>
              {["Orderid", "Orderdate", "Total", "Refundamount", "Refundstatus", "Action"].map((h) => (
                <th key={h} style={{ padding: "10px", border: "1px solid #ddd", textAlign: "left" }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginatedOrders.map((o) => (
              <tr key={o.id}>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{o.orderid}</td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                  {new Date(o.orderdate).toLocaleDateString()}
                </td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{o.total}</td>
             <td style={{ padding: "10px", border: "1px solid #ddd" }}>
  ₹ {Number((o?.refundamount || 0) / 100).toFixed(2)}
</td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{o.refundstatus}</td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                  <button
                    disabled
                    style={{
                      padding: "5px 10px",
                      backgroundColor: "#ccc",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "not-allowed",
                    }}
                  >
                    Cancelled
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      
<div className="pagination-container">

<div style={{color:"black"}}>

Items per page:

<select
className="page-select"
value={pageSize}
onChange={(e) => {
setPageSize(Number(e.target.value));
setPage(1);
}}
>

{[5,10,20,50].map((n)=>(
<option key={n} value={n}>
{n}
</option>
))}

</select>

</div>



<div className="page-buttons">

<button
className="page-btn"
disabled={page===1}
onClick={()=>setPage(page-1)}
>
Previous
</button>


<span className="page-count">

{page} / {totalPages || 1}

</span>


<button
className="page-btn"
disabled={page===totalPages || totalPages===0}
onClick={()=>setPage(page+1)}
>
Next
</button>

</div>


</div>
    </div>
  );
};

export default AdminCancelledOrderList;
